import request from '@/utils/request'

let Service_applyApi = {

  /*服务者入驻列表*/
  list(data) {
    return request._post('/shop/plus.service_apply.Index/index', data);
},
/*添加服务者入驻*/
add(data) {
    return request._post('/shop/plus.service_apply.Index/add', data);
},
audit(data) {
    return request._post('/shop/plus.service_apply.Index/aduit', data);
},
/*修改服务者入驻*/
edit(data) {
    return request._post('/shop/plus.service_apply.Index/edit', data);
},
/*删除服务者入驻*/
del(data) {
    return request._post('/shop/plus.service_apply.Index/del', data);
},
/*服务者入驻详情*/
detail(data) {
  return request._post('/shop/plus.service_apply.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.service_apply.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.service_apply.Setting/getSetting', data, errorback);
    },
}
export default Service_applyApi;



// WEBPACK FOOTER //
// ./src/api/service_apply.js